import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query = '') {
    return ApiService.get(`financial-operation-manager/reports/payment-approvals?${query}`)
  },

  async post (payload) {
    return ApiService.post('financial-operation-manager/reports/payment-approvals', payload)
  },

  async put (payload) {
    return ApiService.put(`financial-operation-manager/reports/payment-approvals/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`financial-operation-manager/reports/payment-approvals/${payload.id}`)
  }
}

export default HistoryService
